query WfaUserOptions {
	wfa_session_runs {
		user_name_group_uniq_array
	}
}
